import { $httpPhoenix } from '@/core/api';
const state = {
    settings: {},
};
const actions = {
    async loadSettings({ commit }) {
        try {
            const resp = await $httpPhoenix.api.getAllSettings();
            commit('setSettings', resp.data);
        }
        catch (err) {
            console.error(err);
        }
    },
};
const mutations = {
    setSettings(state, payload) {
        state.settings = payload;
    },
};
const getters = {
    getSettingByKey: (state) => (key) => {
        return (state.settings[key] ?? null);
    },
};
export const settingsModule = {
    state,
    mutations,
    getters,
    actions,
    namespaced: true,
};
